module.exports = __webpack_public_path__ + "static/media/Tom-Glendinng.000f91a0.jpg";